import Select from "@/common/components/Select";
import { useProducts } from "@/common/hooks/queries/useProducts";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { ProductData } from "@/common/types/product.type";
import { DashboardFilters, DashboardHiddenFilterProps } from "@/features/company/types/dashboards/dashboard.type";

const DashboardFilterProductHiddenFilter = ({
  value,
  onChange,
  watchFilters,
}: DashboardHiddenFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const watchProductCategoryValue = watchFilters?.find(({ key }) => key === DashboardFilters.ProductCategory)?.value;

  const {
    data: productsOptions,
  } = useProducts({
    filters: {
      search,
      category: watchProductCategoryValue?.value || watchProductCategoryValue,
    },
    mapper: Mapper.mapToOptions<ProductData>({
      labelFieldName: 'display_name',
      valueFieldName: 'id',
    }),
  });

  return (
    <Select
      label="Selecione o produto"
      markAsRequired
      options={productsOptions}
      onInputChange={setSearch}
      value={value}
      onChange={onChange}
    />
  );
}

export default DashboardFilterProductHiddenFilter;
